var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    width: 17,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.003.129c.163.09.298.222.39.382l7.475 12.995a.99.99 0 0 1-.39 1.365 1.04 1.04 0 0 1-.503.129H1.025A1.015 1.015 0 0 1 0 13.997c0-.172.045-.341.132-.491L7.606.51A1.04 1.04 0 0 1 9.003.13zm-.478 10.86h-.05a1 1 0 0 0-1 1c0 .558.447 1.006 1 1.006h.05a1 1 0 0 0 1-1c0-.558-.448-1.006-1-1.006zm0-6.015h-.05a1 1 0 0 0-.994.883l-.006.117v3.013a1 1 0 0 0 .883.993l.117.007h.05a1 1 0 0 0 .993-.884l.007-.116V5.974a1 1 0 0 0-1-1z"
  })));
};

export default SvgWarning;